module.exports = __webpack_public_path__ + "media/images/img_ttl-integration-2a913903ab7e29019826f28bb3ea7fee.png";